
export class PaymentTransactionExtension {
}
